export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/healthcheck')) {
    return;
  }

  const rawShopProvider = to.query.sp || to.query.shop_provider;
  const rawValue = Array.isArray(rawShopProvider) ? rawShopProvider[0] : rawShopProvider;

  if (typeof rawValue !== 'string' || !rawValue) {
    return;
  }

  const { setShopProvider } = useShopProvider();
  setShopProvider(rawValue);
});
